import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import SignInComponent from "./main";
import Storage from "@/app/core/util/Storage";

const EmptyRouter = props =>
  Storage.isAuthenticated() ? (
    <Redirect to="/" />
  ) : (
    <div {...props}>{renderRoutes(props.route.routes, props)}</div>
  );

const RecoverRouter = () => ({
  path: "/recuperar-senha",
  exact: true,
  component: EmptyRouter,
  routes: [
    {
      path: "/recuperar-senha",
      component: SignInComponent
    }
  ]
});

export default RecoverRouter();
